"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const core_1 = require("@openhps/core");
const BufferUtils_1 = require("../utils/BufferUtils");
core_1.DataSerializer.registerType(Uint8Array, {
    serializer: BufferUtils_1.toHexString,
    deserializer: BufferUtils_1.fromHexString,
});
tslib_1.__exportStar(require("./RFObject"), exports);
tslib_1.__exportStar(require("./RFReceiverObject"), exports);
tslib_1.__exportStar(require("./RFTransmitterObject"), exports);
tslib_1.__exportStar(require("./WLANObject"), exports);
tslib_1.__exportStar(require("./position"), exports);
tslib_1.__exportStar(require("./BLEObject"), exports);
tslib_1.__exportStar(require("./RFDataFrame"), exports);
tslib_1.__exportStar(require("./BLEUUID"), exports);
tslib_1.__exportStar(require("./MACAddress"), exports);
tslib_1.__exportStar(require("./BLEBeaconObject"), exports);
tslib_1.__exportStar(require("./BLEAltBeacon"), exports);
tslib_1.__exportStar(require("./BLEiBeacon"), exports);
tslib_1.__exportStar(require("./BLEService"), exports);
tslib_1.__exportStar(require("./BLEEddystone"), exports);
tslib_1.__exportStar(require("./BLEEddystoneUID"), exports);
tslib_1.__exportStar(require("./BLEEddystoneURL"), exports);
tslib_1.__exportStar(require("./BLEEddystoneTLM"), exports);
tslib_1.__exportStar(require("./units"), exports);
//# sourceMappingURL=index.js.map